module.exports = __webpack_public_path__ + "img/38.7d75e240.jpg";